exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, "/* ANIMATION */\n/* SHADOWS */\n.OrderDepthItem__container___NS1S {\n  display: flex;\n  margin: 3px 0px;\n  height: 25px;\n  align-items: center;\n  padding-left: 10px; }\n  .OrderDepthItem__container___NS1S a {\n    flex: 1; }\n\n.OrderDepthItem__SELL__35MoW a {\n  color: #b31f1f; }\n  .OrderDepthItem__SELL__35MoW a:hover {\n    color: #b31f1f; }\n\n.OrderDepthItem__BUY__3boXb a {\n  color: #003c77; }\n  .OrderDepthItem__BUY__3boXb a:hover {\n    color: #003c77; }\n", ""]);

// exports
exports.locals = {
	"container": "OrderDepthItem__container___NS1S",
	"SELL": "OrderDepthItem__SELL__35MoW",
	"BUY": "OrderDepthItem__BUY__3boXb"
};